import React from 'react';
import { Eye, EyeOff, ChevronDown } from 'lucide-react';

const FieldRenderer = ({ field, value, onChange, disabled, isDarkMode, showPassword, setShowPassword, ...otherProps }) => {
  const baseInputClasses = `w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
    disabled 
      //? (isDarkMode ? 'bg-gray-700 border-gray-600 cursor-not-allowed text-gray-400' : 'bg-gray-50 border-gray-200 cursor-not-allowed')
      //: (isDarkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-200 text-gray-900')
      ? (isDarkMode ? 'bg-gray-700 border-gray-600 cursor-not-allowed text-gray-400' : 'bg-gray-50 border-gray-200 cursor-not-allowed')
    : (isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-200 text-gray-900')
  }`;

  switch (field.type) {
    case 'text':
    case 'email':
    case 'number':
      return (
        <input
          type={field.type}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className={baseInputClasses}
          placeholder={field.placeholder}
          disabled={disabled}
          autoComplete="off"
          style={{ fontSize: '16px' }}
          min={field.type === 'number' ? field.min : undefined}
        />
      );

    case 'select':
      const selectClasses = `${baseInputClasses} appearance-none cursor-pointer`;
      return (
        <div className="relative">
          <select
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className={selectClasses}
            disabled={disabled}
            style={{ fontSize: '16px' }}
          >
            <option value="">Seleccionar...</option>
            {field.options?.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown 
            className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400" 
            size={16} 
          />
        </div>
      );
    
    case 'password':
      return (
        <>
          <style>
            {`
              input[type="password"]::-ms-reveal,
              input[type="password"]::-ms-clear,
              input[type="password"]::-webkit-password-button,
              input[type="password"]::-webkit-credentials-auto-fill-button {
                display: none !important;
              }
              input[type="password"] {
                -webkit-text-security: disc !important;
                -webkit-appearance: none !important;
                -moz-appearance: none !important;
                appearance: none !important;
              }
              .relative input[type="password"] {
                -webkit-text-security: disc !important;
                -webkit-appearance: none !important;
              }
            `}
          </style>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              value={value || ''}
              onChange={(e) => onChange(e.target.value)}
              className={`${baseInputClasses} pr-12`}
              placeholder={field.placeholder}
              disabled={disabled}
              autoComplete="new-password"
              style={{ fontSize: '16px' }} // Corregí 'font-size' a 'fontSize' para consistencia con JSX
            />
            {value && (
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                disabled={disabled}
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            )}
          </div>
        </>
      );

    case 'textarea':
      return (
        <textarea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className={`${baseInputClasses} min-h-[80px] resize-y`}
          placeholder={field.placeholder}
          disabled={disabled}
          autoComplete="off"
          style={{ fontSize: '16px' }}
        />
      );

    case 'checkbox':
      return (
        <div 
          onClick={() => {
            if (!disabled) {
              onChange(value === 1 ? 0 : 1);
            }
          }}
          className={`w-5 h-5 rounded border-2 flex items-center justify-center cursor-pointer transition-colors ${
            isDarkMode 
              ? `border-gray-500 ${value === 1 ? 'bg-gray-600' : 'bg-gray-800'}`
              : `border-gray-400 ${value === 1 ? 'bg-white' : 'bg-white'}`
          }`}
        >
          {value === 1 && (
            <svg className="w-3 h-3 text-black" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          )}
        </div>
      );
    case 'custom':
      if (field.component) {
        const CustomComponent = field.component;
        return (
          <CustomComponent
            name={field.name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            isDarkMode={isDarkMode}
            tipoPersona={field.tipoPersona}
            {...otherProps}
          />
        );
      }
      return (
        <div className="text-red-500">
          Componente custom no especificado
        </div>
      );

    default:
      return (
        <div className="text-red-500">
          Tipo de campo no soportado: {field.type}
        </div>
      );
  }
};

export default FieldRenderer;